export enum DateTimeTypeEnum {
  TODAY = 'TODAY',
  TOMORROW = 'TOMORROW',
  OTHER = 'OTHER',
}
